// extracted by mini-css-extract-plugin
export var icon = "k+Gki";
export var list = "NPF98";